const actions = {
  FETCH_DEVICES: 'FETCH_DEVICES',
  FETCH_DEVICES_SUCCESS: 'FETCH_DEVICES_SUCCESS',
  FETCH_DEVICES_ERROR: 'FETCH_DEVICES_ERROR',
  DEVICE_SET: 'device/SET_VALUE',
  DEVICE_ADD: 'device/ADD_VALUE',
  DEVICE_DEL: 'device/DEL_VALUE',
  DEVICE_SUCCESS: 'device/SUCCESS',
  DEVICE_ERROR: 'device/ERROR',
}

export default actions
